import styled from "styled-components";

export const InfomationWrapper = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0 70px;
`;

export const InfomationList = styled.ul`
  width: 100%;
`;
